import { render, staticRenderFns } from "./vendeursAvd.vue?vue&type=template&id=3fa67fae&"
import script from "./vendeursAvd.vue?vue&type=script&lang=js&"
export * from "./vendeursAvd.vue?vue&type=script&lang=js&"
import style0 from "./vendeursAvd.vue?vue&type=style&index=0&id=3fa67fae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports